import { ModalWithIcon } from '@components/ModalWithIcon/ModalWithIcon'
import { Container } from '../shared.styles'
import LoadingModal from '@components/LoadingModal/LoadingModal'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { MigrationStatus, useMigrationStatus, isMigrationCompleted } from '../shared'

export default function TemporaryTokenMigrationGuard() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: migration, isLoading: isMigrationStatusLoading, isError } = useMigrationStatus()

  const status = migration?.status
  const shouldShowModal = !isMigrationCompleted(status) && !isError

  const handleGoHome = () => {
    navigate('/home')
  }

  if (!shouldShowModal) {
    return null
  }

  return (
    <Container>
      <LoadingModal visible={isMigrationStatusLoading} />
      <ModalWithIcon
        title={''}
        description={t('common.tokenMigration.guard.message')}
        onPositive={handleGoHome}
        positiveText={t('common.tokenMigration.guard.goHomeButton')}
        type="void"
        visible={shouldShowModal}
      />
    </Container>
  )
}
